import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { TranslateModule } from '@ngx-translate/core';
import { MealPlanService } from '@services/meal-plan.service';

export type OrderMode = 'meal_plan' | 'by_course';

@Component({
  selector: 'app-choose-order-type-page',
  imports: [TranslateModule],
  templateUrl: './choose-order-type-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'block h-full',
  },
})
export class ChooseOrderTypePageComponent {
  private readonly router = inject(Router);
  private readonly mealPlanService = inject(MealPlanService);

  selectMode(mode: OrderMode): void {
    if (mode === 'meal_plan') {
      void this.router.navigate([AppRoutes.chooseMealPlan]);
    } else {
      this.mealPlanService.clearMealPlan();
      void this.router.navigate([AppRoutes.order]);
    }
  }
}
